module.exports = __webpack_public_path__ + "static/media/about-moken-video-img@3x.428328be.jpg";